import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

export default function AppLoader({ fullScreen = false, inline = false, size = 80, label }) {
  const theme = useTheme();
  const { t } = useTranslation();
  return <div className={`polka-loader${fullScreen ? ' polka-loader--screen' : ''}${inline ? ' polka-loader--inline' : ''}`}
    role="status" aria-live="polite" style={{ '--polka-loader-color': theme.colors?.text, '--polka-loader-bg': theme.colors?.background }}>
    <span className="polka-loader-mark" aria-hidden="true" style={{ width: size, height: size * .8, '--polka-loader-scale': size / 300 }}>
      <span className="polka-loader-stage"><span className="polka-loader-line polka-loader-line--left" /><span className="polka-loader-line polka-loader-line--right" /></span>
    </span>
    <span className="polka-loader-label">{label || t('common.loading')}</span>
  </div>;
}
